<div>
  <button class="btn-file" (click)="archivos_adjuntos()" *ngIf="files">
    Subir archivo adjunto
  </button>
  <table class="table mt-2 mb-2" *ngIf="files">
    <thead>
      <tr>
        <th scope="col"></th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let file of files">
        <td style="text-align: left">{{ file.filename }}</td>
        <td style="text-align: right">
          <button class="btn-save" (click)="view(file)">
            <mat-icon>visibility</mat-icon>
          </button>
          <button class="btn-save ml-2" (click)="goTo(file.file_path)">
            <mat-icon>save</mat-icon>
          </button>
          <button class="btn-delete ml-2" (click)="deleteFile(file.filename)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

